import React, { useEffect, useMemo, useState } from "react"
import { merge, get } from "lodash"
import { ipoDataCategory, callIpoApi } from "components/actions/ipo"
import { IPOTemplate } from "components/templates/domestic/ipo"
import { PAGE_NUM } from "config/const"
import uuid from "uuid"
import { checkIsSp } from "utils/util"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const IPO: React.FC = () => {
  const isPhone = checkIsSp()
  const loadResistId = useMemo(() => uuid(), [])
  const [refreshFlag, setRefreshFlag] = useState(false)
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const [ipoData, setIpoData] = useState([])
  const [currentPage, ChangePage] = useState(0)
  const [activeLabel, changeLabel] = useState(0)

  const label = [
    { id: 0, name: "本日公開" },
    { id: 1, name: "公開予定" },
    { id: 2, name: "公開済" },
  ]

  const ipoList = {
    data: ipoData,
    setData: setIpoData,
    currentPage: currentPage,
    changePage: ChangePage,
    ipoDataCategory: ipoDataCategory[activeLabel],
  }
  const labelItem = {
    label: label,
    activeLabel: activeLabel,
    changeLabel: changeLabel,
  }
  const defaultParam = {
    _skip: currentPage * PAGE_NUM.PAGE_10,
    _take: PAGE_NUM.PAGE_10,
    _orderBy: "ApplyDayFrom desc",
  }

  useEffect(() => {
    callIpoApi(
      isPhone
        ? get(ipoDataCategory, `[${activeLabel}].mergeParam`)
        : merge(
            defaultParam,
            get(ipoDataCategory, `[${activeLabel}].mergeParam`)
          ),
      setIpoData,
      loadResistId
    )
  }, [activeLabel, currentPage])

  //ページ更新
  useEffect(() => {
    if (isPageLoading)
      callIpoApi(
        isPhone
          ? get(ipoDataCategory, `[${activeLabel}].mergeParam`)
          : merge(
              defaultParam,
              get(ipoDataCategory, `[${activeLabel}].mergeParam`)
            ),
        setIpoData,
        loadResistId
      )
  }, [isPageLoading])

  useEffect(() => {
    if (refreshFlag) {
      callIpoApi(
        isPhone
          ? get(ipoDataCategory, `[${activeLabel}].mergeParam`)
          : merge(
              defaultParam,
              get(ipoDataCategory, `[${activeLabel}].mergeParam`)
            ),
        setIpoData,
        loadResistId
      )
      setRefreshFlag(false)
    }
  }, [refreshFlag])

  return (
    <IPOTemplate
      ipoDataList={ipoList}
      labelItem={labelItem}
      isPhone={isPhone}
      setRefreshFlag={setRefreshFlag}
    />
  )
}
